var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{ref:"chartMap",staticClass:"echarts",attrs:{"id":"chartMap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }